import React from 'react';
import { Button, Dropdown, DropdownButton, Form, FormControl, InputGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { API_ROOT, NO_INDEX_FILE, REGEX_DOMAIN, REGEX_PASSWORD, REGEX_USERNAME } from '../../../../constants';
import SelectedFile from '../../../SelectedFile';
import { STATE_SUCCESS } from '../index';
import api from '../../../../utils/api';
import {
  fetchUserData,
  setDraggedFile,
  showCreateSiteModal,
  showCustomDomainModal,
  showMessageModal,
  showUpgradeModal
} from '../../../../Manage/actions';

import { PRO_MAX_FILE_SIZES } from '../../../../constants/plans';
import { getErrorMessage, getSubdomainAndTLD, getTLDs } from '../../../../utils/general';
import ContentSelector from '../../../ContentSelector/ContentSelector';
import CustomTooltip from '../../../CustomTooltip';
import pro from '../../../../constants/plans/pro';
import { getSimulationDuration } from '../../../ProgressBar/ProgressBar';
import FileListModal from 'components/FileListModal/FileListModal';

import '../../../../App.css';
import './CreateUpdateSite.css';

export const ACTION_UPDATE = 'UPDATE';
export const ACTION_EXTEND = 'EXTEND';
export const ACTION_CREATE = 'CREATE';

const LABEL_MAP = {
  [ACTION_CREATE]: 'LAUNCH',
  [ACTION_UPDATE]: ACTION_UPDATE
};

class CreateUpdateSite extends React.Component {
  state = {
    invalidFields: [],
    draggedfile: null
  };

  constructor(props) {
    super(props);
    const { data } = props;
    const tlds = getTLDs({ account: this.props?.userProfile });
    this.state = {
      ...this.state,
      subdomain: data?.domain?.split('.')[0],
      passwordProtected: data?.passwordProtected || false,
      disableExportPdf: data?.disableExportPdf || false,
      password: data?.password || undefined,
      username: data?.username || undefined,
      domainSuffix: getSubdomainAndTLD({ site: { subdomain: data?.domain } }).tld || tlds[0],
      showFileList: false,
      tlds
    };
  }

  onFileSelected = (files) => {
    const { userProfile, dispatch } = this.props;
    const file = files[0] || draggedFileValue;
    const maxSizeMB = userProfile.fileUploadLimit || PRO_MAX_FILE_SIZES[userProfile.productId] || 3;
    if (file) {
      if (file.size < 1024 * 1024 * maxSizeMB) {
        dispatch(setDraggedFile(file));
        this.setState({ progress: 0 });
      } else {
        alert(`Files should be less than ${maxSizeMB}MB. Upgrade for more.`);
      }
    }
  };

  onIndexFileSelected = (file) => {
    this.setState(
      {
        showFileList: false,
        indexFile: file
      },
      () => {
        this.onSubmit();
      }
    );
  };

  onFieldChange = (field, value) => this.setState({ [field]: value });

  validateField = (field, value) => {
    if (field === 'subdomain') return REGEX_DOMAIN.test(value?.toLowerCase());

    if (field === 'username') return REGEX_USERNAME.test(value?.toLowerCase());

    if (field === 'password')
      // colon(:) charecter is not allowed in password
      return REGEX_PASSWORD.test(value?.toLowerCase());
  };

  onTemplateSelected = (value) => {
    this.props.dispatch(setDraggedFile(value));
  };

  validFields = () => {
    const invalidFields = [];
    const { draggedFileValue } = this.props;

    const { subdomain, username, password, passwordProtected } = this.state;

    if (subdomain && !this.validateField('subdomain', subdomain)) invalidFields.push('subdomain');

    if (passwordProtected && (!username || !this.validateField('username', username))) invalidFields.push('username');

    if (passwordProtected && (!password || !this.validateField('password', password))) invalidFields.push('password');

    if (!draggedFileValue) invalidFields.push('draggedFileValue');

    this.setState({ invalidFields });
    return invalidFields.length === 0;
  };

  onSubmit = async () => {
    if (!this.validFields()) return;

    const { setRootState, action, draggedFileValue } = this.props;
    const { subdomain, domainSuffix, username, password, passwordProtected, indexFile, disableExportPdf } = this.state;
    const formData = new FormData();
    formData.append('subdomain', subdomain ? subdomain.toLowerCase() : '');
    formData.append('domainSuffix', domainSuffix);

    if (indexFile) {
      formData.append('indexFile', indexFile);
    }

    if (draggedFileValue.isTemplate) {
      formData.append('useTemplate', draggedFileValue.path);
    } else {
      formData.append('file', draggedFileValue);
    }

    formData.append('passwordProtected', passwordProtected);
    if (passwordProtected && username && password) {
      formData.append('username', username);
      formData.append('password', password);
    }

    if(disableExportPdf) {
      formData.append('disableExportPdf', disableExportPdf);
    }

    setRootState({ isLoading: true });

    if (this.props.draggedFileValue.size > 1024 * 1024 * 20) {
      setRootState({ showProgressBar: true });
    }

    const recaptchaValue = await this.props.googleReCaptchaProps.executeRecaptcha('pro');
    const headers = {
      'x-recaptcha': recaptchaValue
    };

    const uploadProgress = (event) => {
      const progress = Math.round(((100 * event.loaded) / event.total) * 0.5);
      setRootState({ progress });

      if (progress === 50) {
        setRootState({
          simulateProgress: true,
          progressBarSimulationDuration: getSimulationDuration(this.props.draggedFileValue.size)
        });
      }
    };

    const endpoint = `${API_ROOT}/pro/${action.toLowerCase()}`;
    api
      .post(endpoint, formData, headers, uploadProgress)
      .then((res) => {
        this.props.dispatch(fetchUserData());
        this.setState({
          isFetching: false,
          siteLive: true
        });
        setRootState({
          isLoading: false,
          showProgressBar: false,
          progress: 0,
          stage: STATE_SUCCESS,
          domain: res.data.created,
          uploaded: res.data.uploaded
        });

        // For quick update functionality
        const data = res?.data?.data;
        this.props.dispatch(
          showCreateSiteModal(
            true,
            {
              ...data,
              domain: data?.subdomain
            },
            ACTION_UPDATE
          )
        );
      })
      .catch((err) => {
        const htmlFiles = err?.response?.data?.htmlFileList;
        const isValidResponse = err?.response?.data?.code === NO_INDEX_FILE && htmlFiles?.length > 0;

        this.setState({
          isFetching: false,
          showLoading: false,
          showFileList: isValidResponse,
          htmlFiles: htmlFiles
        });
        setRootState({
          isLoading: false,
          showError: !isValidResponse,
          showProgressBar: false,
          progress: 0,
          errorMessage: getErrorMessage(err)
        });
      });
  };

  onSelectDomainSuffix = (eK, e) => {
    const subdomain = this.state.subdomain;
    const selectedDomainSuffix = e.target.text;
    this.setState({
      domainSuffix: selectedDomainSuffix
    });
    if (!subdomain && !this.state.tlds.includes(selectedDomainSuffix)) {
      this.onFieldChange('subdomain', 'www');
    } else if (this.state.tlds.includes(selectedDomainSuffix) && subdomain === 'www') {
      this.onFieldChange('subdomain', '');
    }
  };

  onAddCustomDomain = () => {
    const { dispatch, disableProFeatures, userProfile, customDomains } = this.props;

    dispatch(showCreateSiteModal(false));

    if (disableProFeatures) {
      dispatch(showUpgradeModal(true));
    } else if (userProfile.siteLimit === customDomains.length) {
      dispatch(showMessageModal({ title: 'Limit reached', message: 'Custom domain limit reached' }));
    } else {
      dispatch(showCustomDomainModal(true));
    }
  };

  render() {
    const { action, disableProFeatures, customDomains, draggedFileValue } = this.props;
    const { subdomain, username, password, invalidFields, passwordProtected, domainSuffix, disableExportPdf } = this.state;
    return (
      <div>
        <InputGroup className="input-domain">
          <InputGroup>
            <FormControl
              placeholder="link-name"
              aria-label="Subdomain"
              value={subdomain}
              onChange={(e) => this.onFieldChange('subdomain', e.target.value)}
              disabled={action !== ACTION_CREATE}
            />
            <DropdownButton
              id="input-group-dropdown-2"
              variant="primary"
              as={InputGroup.Append}
              title={domainSuffix}
              value={domainSuffix}
              onSelect={this.onSelectDomainSuffix}
              disabled={action !== ACTION_CREATE}
            >
              {this.state.tlds.map((d) => (
                <Dropdown.Item key={d} value={d}>{d}</Dropdown.Item>
              ))}
              {customDomains.map((c) => (
                <Dropdown.Item key={c} value={`.${c.domain}`} active={domainSuffix === `.${c.domain}`}>
                  .{c.domain}
                </Dropdown.Item>
              ))}
              <Dropdown.Divider />
              <Dropdown.Item key={1} onClick={this.onAddCustomDomain}>
                <span style={{ fontSize: '14px', color: '#333' }}>
                  {' '}
                  Add custom domain{' '}
                  {disableProFeatures && <img alt="Pro" src="assets/icons/pro-black.png" height="20" />}
                </span>
              </Dropdown.Item>
            </DropdownButton>
          </InputGroup>
        </InputGroup>
        {invalidFields.includes('subdomain') && (
          <div className="mt-1 validation-error text-center">
            Please enter a valid website name.{' '}
            <CustomTooltip label="Only letters, numbers & hyphens (-) are allowed. No spaces.">
              <span className="link">
                <u>Help</u>
              </span>
            </CustomTooltip>
          </div>
        )}
        {action !== ACTION_EXTEND && (
          <>
            {draggedFileValue ? (
              <SelectedFile
                className="justify-center"
                file={draggedFileValue}
                onRemove={() => this.props.dispatch(setDraggedFile(null))}
                disableProFeatures={disableProFeatures}
                disableExportPdf={disableExportPdf}
                disableExportPdfChange={() => this.setState({ disableExportPdf: !disableExportPdf })}
              />
            ) : (
              <ContentSelector
                className="tr-landing-upload-file-zone m-3"
                onDrop={this.onFileSelected}
                onTemplateSelected={(template) => this.onTemplateSelected(template)}
              />
            )}
          </>
        )}
        {invalidFields.includes('draggedFileValue') && (
          <div className="validation-error text-center">Please select a file</div>
        )}
        <div className="flex p-2">
          <div className="p-2 align-content-center m-auto">
            <Form.Check
              checked={passwordProtected}
              id="password-protect"
              className="tmb-3"
              type="switch"
              label={
                <span>
                  Password protect{' '}
                  {disableProFeatures && <img alt="Pro" src="assets/icons/pro-black.png" height="20" />}
                </span>
              }
              onChange={() => this.setState({ passwordProtected: !passwordProtected })}
              disabled={disableProFeatures}
            />
            {passwordProtected && (
              <>
                <InputGroup>
                  <InputGroup.Text>Username</InputGroup.Text>
                  <FormControl
                    type="text"
                    placeholder="Username"
                    aria-label="Username"
                    aria-describedby="inputGroupPrepend"
                    onChange={(e) => this.onFieldChange('username', e.target.value)}
                    name="username"
                    value={username}
                  />
                </InputGroup>
                {invalidFields.includes('username') && (
                  <div className="validation-error">Please enter a valid username</div>
                )}
                <InputGroup>
                  <InputGroup.Text>Password</InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Password"
                    aria-label="Password"
                    aria-describedby="inputGroupPrepend"
                    onChange={(e) => this.onFieldChange('password', e.target.value)}
                    name="password"
                    value={password}
                  />
                </InputGroup>
                {invalidFields.includes('password') && (
                  <div className="validation-error">Please enter a valid password</div>
                )}
              </>
            )}
          </div>
        </div>
        <Button className="action-btn round-top-0" onClick={this.onSubmit}>
          {LABEL_MAP[action]}
        </Button>
        {this.state.htmlFiles?.length > 0 && (
          <FileListModal
            show={this.state.showFileList}
            onHide={() => this.setState({ showFileList: false })}
            onFileSelected={this.onIndexFileSelected}
            filesList={this.state.htmlFiles}
            title="Which file should be your homepage?"
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ manage }) => ({
  draggedFileValue: manage.draggedFile,
  userProfile: manage.userProfile,
  customDomains: manage.customDomains.filter((c) => ['CONNECTED', 'VALIDATED'].includes(c.status.toUpperCase()))
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(withGoogleReCaptcha(CreateUpdateSite));
